module.exports = __webpack_public_path__ + "img/087.e9e86b3a.png";